<template>
  <div>
    <div v-if="loading">
      <p>Cargando..</p>
    </div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orderapplicationsEmergency')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Crear Pedido Emergente
      </h1>
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
            Datos Pedido
          </a>
        </li>
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="store">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <div class="container pb-8 pr-6 w-full lg:w-2/6">
                <label class="form-label" >Para:</label>
                <v-select v-model="form.user_id" :options="userss" value="id" label="fullname" ></v-select>
                </div>  
                <div v-if="$page.props.auth.user.rol !='Mecanica'" class="container pb-8 pr-6 w-full lg:w-2/6">
                <label class="form-label" >Proyecto:</label>
                <v-select v-model="form.project_id" :options="projectss" value="id" label="name" ></v-select>
                </div>  
                
                <div v-if="$page.props.auth.user.rol !='Mecanica'" class="container pb-8 pr-6 w-full lg:w-1/6">
                <label class="form-label" >Manzana:</label>
                <v-select v-model="form.project_apple_id" :options="appless" value="id" label="name" ></v-select>
              </div>  
              <div v-if="$page.props.auth.user.rol !='Obras'" class="container pb-8 pr-6 w-full lg:w-3/6">
                <label class="form-label" >Activo:</label>
                <v-select v-model="form.machinery_id" :options="machineryss" value="id" label="name" ></v-select>
                </div>  
                <select-input v-model="form.reembolso" :error="form.errors.rol" class="pr-6 pb-8 w-full lg:w-1/6" label="Reembolso" required>
                  <option>NO</option>
                  <option>SI</option>
                   </select-input>
                   <div v-if="form.reembolso=='SI'" class="container pb-8 pr-6 w-full lg:w-2/6">
                <label class="form-label" >Empresa que se compra:</label>
                <v-select v-model="form.organization_idReembolso" :options="organizationss" value="id" label="tradename" required></v-select>
                </div>  
            <textarea-input v-model="form.observation" :error="form.errors.observation" :req="form.observation" class="pb-8 pr-6 w-full lg:w-4/6" label="Observación" />
      
              </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Solicitud</loading-button>
        </div>
      </form>
            </div>
            <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
            </div>
          </div>
        </div>
       
      </div>
    </div>
  </div>
  <preloader />
  </div>
  
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo: { title: 'Crear Pedido Emergente' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    vSelect,
    TextareaInput,
  },
  layout: Layout,
  props: {
    organizations: Array,
    users: Array,
    projects: Array,
    apples: Array,
    machinerys: Array,

  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      loading: true,
      userss: this.users,
      projectss: this.projects,
      appless: this.apples,
      machineryss: this.machinerys,
      organizationss: this.organizations,
      form: this.$inertia.form({
        user_id: null,
        project_id:null,
        project_apple_id: null,
        machinery_id: null,
        observation: null,
        emergency: 'SI',
        organization_idReembolso: null,
        reembolso: 'NO',

      }),
    }
  },
  async mounted(){
    await this.users
    this.loading=false
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    store() {
      
      this.form.post('/orderapplications')
    },
   
  },
}
</script>